<app-core-popup
  [header]="'service-price.header' | translate"
  [dialogStyle]="{ width: '90vw', 'min-height': '75vh' }"
  (closeOn)="onPopupClosed()"
  [saveText]="'common.save' | translate"
  [saveButtonDisable]="!(selectedServices.length > 0)"
  (chooseOn)="save()"
  #popup
>
  <div *ngIf="openPopup">
   <div class="row" *ngIf="priceTypeLabel">
  <div class="col-md-5 mb-3">
    <div class="alert alert-info d-flex align-items-center" role="alert">
      <i class="pi pi-tag me-2"></i>
      <div>
        <strong>Seçili Fiyat Tipi:</strong> {{ priceTypeLabel }}
      </div>
    </div>
  </div>
</div>
    <div class="row">
      <div class="col-md-3 mb-3">
        <div class="form-group">
          <label for="">{{ "service-price.service" | translate }} </label>
          <input
            type="text"
            [(ngModel)]="filter.search"
            (ngModelChange)="applySearchFilter()"
            [placeholder]="'service-price.service-placeholder' | translate"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-3 mb-3">
        <div class="form-group">
          <label for="">
            {{ "service-price.parent-group" | translate }}
          </label>
          <p-dropdown
            [options]="parentGroups"
            appendTo="body"
            [filter]="true"
            [showClear]="true"
            [placeholder]="'service-price.parent-group' | translate"
            (onChange)="filterParentGroupChange($event)"
            [(ngModel)]="filter.serviceParentGroupId"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="col-md-3 mb-3">
        <div class="form-group">
          <label for="">
            {{ "service-price.sub-group" | translate }}
          </label>
          <p-dropdown
            [disabled]="!filter.serviceParentGroupId"
            [options]="filteredSubgroups"
            appendTo="body"
            [filter]="true"
            [placeholder]="'service-price.sub-group' | translate"
            [group]="true"
            [showClear]="true"
            [(ngModel)]="filter.serviceGroupId"
            (ngModelChange)="subGroupChange()"
          >
          </p-dropdown>
        </div>
      </div>
      <div class="col-md-3 mb-3">
        <div class="form-group">
          <label for="">
            {{ "service-price.panels" | translate }}
          </label>
          <p-dropdown
            [options]="servicePanels"
            appendTo="body"
            [placeholder]="'service-price.panels' | translate"
            [filter]="true"
            [(ngModel)]="filter.servicePanelId"
          >
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-end mt-3">
        <button
          class="btn btn-danger light"
          (click)="clearFilters()"
          type="button"
        >
          {{ "general.clear-filter" | translate }}
        </button>
        <button (click)="getList({})" class="btn btn-info ms-2" type="button">
          {{ "general.filtering" | translate }}
          <i class="fa fa-search ms-2"></i>
        </button>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-5">
        <p-table
          [value]="allServices"
          scrollHeight="40vh"
          [(selection)]="selectedServices"
          selectionMode="multiple"
          dataKey="serviceId"
          [lazy]="true"
          (onLazyLoad)="getList($event)"
          [rowHover]="true"
          responsiveLayout="stack"
          paginatorDropdownAppendTo="body"
          [lazy]="true"
          [scrollable]="true"
          (selectionChange)="rowSelect()"
        >
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" style="width: 10%;">
                <p-tableHeaderCheckbox
                  (onChange)="onSelectAllChange($event)"
                ></p-tableHeaderCheckbox>
              </th>
              <th scope="col" style="width:50%;">
                {{ "service-price.service" | translate }}
              </th>
              <th scope="col" style="width: 20%;" class="text-end">
                {{ "service-price.gate-price" | translate }}
              </th>
              <th scope="col" style="width: 20%;" class="text-end">
                {{ "service-price.member-price" | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-service>
            <tr
              style="height: 4rem"
              [pSelectableRow]="service"
              [pSelectableRowDisabled]="
                (service?.gatePrice?.originalPrice === null ||
                  service?.gatePrice?.originalPrice === undefined) &&
                (service?.memberPrice?.originalPrice === null ||
                  service?.memberPrice?.originalPrice === undefined)
              "
            >
              <td (click)="$event.stopPropagation()" role="button"  tabindex="-1">
                <p-tableCheckbox
                  [value]="service"
                  [disabled]="
                    (service?.gatePrice?.originalPrice === null ||
                      service?.gatePrice?.originalPrice === undefined) &&
                    (service?.memberPrice?.originalPrice === null ||
                      service?.memberPrice?.originalPrice === undefined)
                  "
                />
              </td>
              <td>{{ service?.serviceCode }}-{{ service?.serviceName }}</td>
              <td class="text-end">
                @if(service?.gatePrice?.originalPrice===undefined ||
                service?.gatePrice?.originalPrice===null ){
                <span class="badge light border-0 badge-{{ 'danger' }}">
                  {{ "service-price.not-found" | translate }}
                </span>
                }@else {
                {{ service?.gatePrice?.originalPrice | numberComma }}
                {{ service?.gatePrice?.icon ?? service?.gatePrice?.currency }}
                }
              </td>
              <td class="text-end">
                @if(service.memberPrice?.originalPrice===undefined ||
                service.memberPrice?.originalPrice===null ){
                <span class="badge light border-0 badge-{{ 'danger' }}">
                  {{ "service-price.not-found" | translate }}
                </span>
                }@else {
                {{ service?.memberPrice?.originalPrice | numberComma }}
                {{ service?.memberPrice?.icon ?? service?.memberPrice?.currency }}
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="9">{{ "common.noData" | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="col-md-1">
        <p-divider layout="vertical"> </p-divider>
      </div>
      <div class="col-md-5">
        <p-table
          [value]="selectedServices"
          responsiveLayout="stack"
          [scrollable]="true"
          [rowHover]="true"
          scrollHeight="30vh"
          [tableStyle]="{ 'max-width': '45vw' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" style="width: 60%;">
                {{ "service-price.service" | translate }}
              </th>
              <th scope="col" style="width: 20%;">
                {{ "service-price.quantity" | translate }}
              </th>
              <th scope="col" style="width: 20%;">
                {{ "service-price.price" | translate }}
              </th>
              <th scope="col"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-service>
            <tr style="height: 4rem">
              <td class="service-name">{{ service?.serviceName }}</td>
              <td>
                <input
                  type="number"
                  [(ngModel)]="service.quantity"
                  appPreventNegativeInput
                  [inputType]="'integer'"
                  style="width: 60px"
                  (ngModelChange)="onQuantityChange($event, service)"
                  [min]="1"
                  [max]="99"
                  class="form-control"
                />
              </td>
              <td>
                @if(service.total!==null && service.total!==undefined){
                {{ service?.total | numberComma }} ₺
              } @else {
                <span class="badge light border-0 badge-{{ 'danger' }}">
                  {{ "service-price.not-found" | translate }}
                </span>
                }
              </td>
              <td>
                <button
                  type="button"
                  (click)="deleteItem(service)"
                  class="btn btn-danger btn-icon-xxs me-3"
                >
                  <i class="fas fa-trash-alt"></i>
                </button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="9">{{ "common.noData" | translate }}</td>
            </tr>
          </ng-template>
        </p-table>

        <div
          class="d-flex justify-content-end mt-2"
          *ngIf="selectedServices.length > 0"
        >
          <div>
            <span class="badge me-2 light border-0 badge-{{ 'info' }}">
              {{ "service-price.number-of-service" | translate }}:
              <strong>{{ numberOfService }}</strong>
            </span>
            <span class="badge light border-0 badge-{{ 'info' }}">
              {{ "service-price.total" | translate }}:<strong
                >{{ total | numberComma }} ₺</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-core-popup>

<app-loading [loading]="loading" [fullScreen]="true"></app-loading>
